import React, { useState, useEffect } from 'react';
import { FaMedal } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './MyCourses.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { apiFetch } from '../../utils/api';
import Statistics from '../../images/Statistics.jpg';
import Sqlimage from '../../images/Sqlimage.jpg';
import salesforce from '../../images/salesforce.png';
import productengineeringandservices from '../../images/productengineeringandservices.png';
import H1BSTAFF from '../../images/H1BSTAFF.png';
import erp from '../../images/erp.png';
import entierpriseandarchitecture from '../../images/entierpriseandarchitecture.png';
import datascienceandai from '../../images/datascienceandai.png';
import machinelearning from '../../images/machinelearning.jpg';
import azure from '../../images/azure.jpg';
import aws from '../../images/aws.jpg';
import airflow from '../../images/airflow.jpg';
import dbt from '../../images/dbt.jpg';
import deeplearning from '../../images/deeplearning.jpg';
import kafka from '../../images/kafka.jpg';
import gcp from '../../images/gcp.jpg';
import tableau from '../../images/tableau.jpg';
import pyspark from '../../images/pyspark.jpg';
import r from '../../images/r.jpg';
import matplotlib from '../../images/matplotlib.jpg';
import pandas from '../../images/pandas.jpg';
import hadoop from '../../images/hadoop.jpg';
import numpy from '../../images/numpy.jpg';
import oci from '../../images/oci.jpg';
import automation from '../../images/automation.jpg';
import springboot from '../../images/springboot.jpg';
import react from '../../images/react.jpg';
import mulesoft from '../../images/mulesoft.jpg';
import kubernetes from '../../images/kubernetes.png';
import java from '../../images/java.jpg';
import javascript from '../../images/javascript.jpg';
import django from '../../images/django.jpg';
import angular from '../../images/angular.jpg';
import course1 from '../../images/course1.jpg';
import Pagination from '../../components/Pagination';

const courseImageMap = {
  "Statistics": Statistics,
  "SQL": Sqlimage,
  "Salesforce": salesforce,
  "Product Engineering": productengineeringandservices,
  "H1B STAFF": H1BSTAFF,
  "ERP": erp,
  "Enterprise Architecture": entierpriseandarchitecture,
  "Data Science & AI": datascienceandai,
  "Machine Learning": machinelearning,
  "Azure": azure,
  "AWS": aws,
  "Airflow": airflow,
  "DBT": dbt,
  "Deep Learning": deeplearning,
  "Kafka": kafka,
  "GCP": gcp,
  "Tableau": tableau,
  "PySpark": pyspark,
  "R": r,
  "Matplotlib": matplotlib,
  "Pandas": pandas,
  "Hadoop": hadoop,
  "NumPy Beginner": numpy,
  "OCI": oci,
  "Automation": automation,
  "Spring Boot": springboot,
  "React": react,
  "MuleSoft": mulesoft,
  "Kubernetes": kubernetes,
  "Java": java,
  "JavaScript": javascript,
  "Django": django,
  "Angular": angular,
  "Python": course1,
  "Gen AI": datascienceandai,
};

const MyCourses = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('All courses');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [userId, setUserId] = useState(null);
  const [userCertificates, setUserCertificates] = useState([]);

  useEffect(() => {
    const fetchEnrolledCoursesAndCertificates = async () => {
      try {
        setLoading(true);
        const userEmail = localStorage.getItem('userEmail');
        if (!userEmail) {
          setLoading(false);
          return;
        }

        const userInfo = await apiFetch(`${window._env_.API_BASE_URL}/users/info?email=${userEmail}`);
        setUserId(userInfo.user_id);

        const [enrolledCourses, coursesProgress, certificates] = await Promise.all([
          apiFetch(`${window._env_.API_BASE_URL}/users/${userInfo.user_id}/courses`),
          apiFetch(`${window._env_.API_BASE_URL}/users/${userInfo.user_id}/courses/progress`),
          apiFetch(`${window._env_.API_BASE_URL}/certificates/user/${userInfo.user_id}`)
        ]);

        setUserCertificates(certificates && certificates.length > 0 ? certificates.map(cert => cert.course_name) : []);

        const progressMap = coursesProgress && coursesProgress.length > 0 ? coursesProgress.reduce((acc, progress) => {
          acc[progress.course_id] = progress.progress_percent;
          return acc;
        }, {}) : {};

        const formattedCourses = enrolledCourses && enrolledCourses.length > 0 ? enrolledCourses.map(course => {
          const progress = progressMap[course.course_id] || 0;
          const normalizedTitle = course.course_title.replace(` ${course.course_level}`, '').trim();
          const image = courseImageMap[normalizedTitle] || course1;
          return {
            id: course.course_id,
            name: course.course_title,
            department: course.department_name,
            status: progress === 100 ? 'Completed' : (progress > 0 ? 'In Progress' : 'Not Started'),
            progress,
            category: course.course_category || 'General',
            level: course.course_level || 'Beginner',
            total_duration: course.total_duration || 'N/A',
            video_count: course.video_count || 0,
            image
          };
        }) : [];

        setCourses(formattedCourses);
      } catch (err) {
        if (err.message.includes('404')) {
          setCourses([]);
          setUserCertificates([]);
        } else {
          setError(err.message);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchEnrolledCoursesAndCertificates();
  }, []);

  const handleUnenroll = async (courseId) => {
    if (!userId) {
      toast.error('User ID not found. Please log in again.');
      return;
    }

    try {
      const response = await apiFetch(
        `${window._env_.API_BASE_URL}/users/unenroll?user_id=${userId}&course_id=${courseId}`,
        { method: 'DELETE' }
      );

      toast.success('User unenrolled successfully');
      setCourses(courses.filter(course => course.id !== courseId));
    } catch (err) {
      toast.error(`Error: ${err.message}`);
    }
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1);
  };

  const filteredCourses = courses.filter(course => {
    if (activeTab === 'All courses') return true;
    if (activeTab === 'In progress') return course.status === 'In Progress';
    if (activeTab === 'Completed') return course.status === 'Completed';
    return true;
  });

  const paginatedCourses = filteredCourses.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  if (loading) return <div className="my-courses">Loading...</div>;

  if (error) return <div className="my-courses-error">Unable to fetch courses at this time. Please try again later.</div>;

  return (
    <div className="my-courses">
      <ToastContainer />
      <h1>My Courses</h1>
      <p>Continue learning where you left off</p>

      <div className="tabs">
        <span className={activeTab === 'All courses' ? 'active' : ''} onClick={() => handleTabClick('All courses')}>All courses</span>
        <span className={activeTab === 'In progress' ? 'active' : ''} onClick={() => handleTabClick('In progress')}>In progress</span>
        <span className={activeTab === 'Completed' ? 'active' : ''} onClick={() => handleTabClick('Completed')}>Completed</span>
      </div>

      <div className="course-grid">
        {paginatedCourses.length > 0 ? (
          paginatedCourses.map(course => (
            <div className="course-card" key={course.id}>
              <div style={{ position: 'relative' }}>
                <img src={course.image} alt={course.name} className="course-image" />
              </div>
              <div className="course-info">
                <span className="course-category">{course.category}</span>
                <span className="course-level">{course.level}</span>
              </div>
              <h3 className="course-title">{course.name}</h3>

              <p className="course-description">🎥 Videos: {course.video_count}</p>
              <p className="course-description">⏱ Duration: {course.total_duration}</p>

              <div className="course-enroll-section">
                <div className="progress-bar">
                  <div className="progress" style={{ width: `${course.progress}%` }}></div>
                </div>
                <span className="progress-label">Progress: {course.progress}%</span>

                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Link
                    to="/course-videos"
                    state={{ courseTitle: course.name, department: course.department, courseId: course.id }}
                    className={course.status === 'Completed' ? 'completed-btn' : 'enroll-btns'}
                  >
                    {course.status === 'Completed' ? 'Completed' : course.status === 'In Progress' ? 'Continue Learning' : 'Start Learning'}
                  </Link>
                  {course.status === 'Completed' && userCertificates.includes(course.name) && (
                    <span title="Certificate awarded" style={{ display: 'flex', alignItems: 'center', color: '#FFD700', fontSize: 22 }}>
                      <FaMedal />
                    </span>
                  )}
                </div>

                {course.progress !== 100 && (
                  <button
                    className="unenroll-btn"
                    onClick={() => handleUnenroll(course.id)}
                  >
                    Unenroll
                  </button>
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="no-courses">No courses Found!</div>
        )}
      </div>

      {paginatedCourses.length > 0 && (
        <Pagination
          items={filteredCourses}
          itemsPerPage={itemsPerPage}
          setItemsPerPage={setItemsPerPage}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )}
    </div>
  );
};

export default MyCourses;